import { Card } from '@deckee/deck-hand';
import styled from 'styled-components';

const SectionCard = styled(Card)`
  border-style: solid;
  border-width: 0.5px;
  border-color: ${({ theme }) => theme.colors.lightergrey};
`;

export default SectionCard;
